import React from "react";
import {Row, Col} from "antd";
import Lazyload from "react-lazyload";
import data from "./data";

const About : React.FC = () => {
    return (
        <section id={"about"} className={"main-about"}>
            <div className={"public-container"}>
                <Row gutter={[50, 10]}>
                    <Col md={8} sm={24} xs={24}>
                        <div className={"section-heading"}>
                            <h2 className={"title"}>{data.about.id.title}</h2>
                            {/*<div className={"line"}/>*/}
                            {/*<hr className={"line"} />*/}
                        </div>
                    </Col>
                    <Col md={16} sm={24} xs={24}>
                        <div className={"card-wrapper"}>
                            <p className={"subtitle"}>{data.about.id.subTitle}</p>
                            <Row gutter={[50, 30]}>
                                {
                                    data.about.id.advantages.map(item => (
                                        <Col  lg={12} md={12} sm={24} xs={24} key={item.img}>
                                            <div className={"about-card"}>
                                                <Lazyload height={84} offset={100}>
                                                    <img src={item.img} width={50} height={50} alt={item.title} />
                                                </Lazyload>
                                                <h3>{item.title}</h3>
                                                <p>{item.description}</p>
                                            </div>
                                        </Col>
                                    ))
                                }
                            </Row>
                        </div>
                    </Col>
                </Row>
            </div>
        </section>
    )
}

export default React.memo(About);